import CPNWReviewerPage from "./CPNWReviewerPage";

export default CPNWReviewerPage